import http from '@/utils/http';
export class LogoutApi {
    static async logout() {
        try {
            await http.post('/test/logout');
        }
        catch (error) {
            console.error('Logout 请求失败:', error);
            throw error;
        }
    }
}
export default LogoutApi;
